<app-rmpv-oficina-mensal-filtro [filtros]="filtros"></app-rmpv-oficina-mensal-filtro>
<app-barra-consulta-mensal *ngIf="!carregando" visible="false" [listagemComFiltros]="getListagemComFiltros()"
  (atualizando)="atualizar($event)" (inserindo)="novo($event)" (definirFiltro)="definirFiltragem()" [exibirNovo]="false"
  (voltando)="voltar()">
</app-barra-consulta-mensal>
<app-loading [exibir]="carregando"></app-loading>

<div class="conteudo">
  <div *ngIf="barChartData.length && !carregando" style="width: 98%">
    <canvas height="100" baseChart [datasets]="barChartData" [labels]="barChartLabels" [colors]="barChartColors"
      [options]="barChartOptions" [legend]="barChartLegend" [chartType]="barChartType">
    </canvas>
  </div>
  <!------------------------- Estrutura da GRIDvalida até Media Screen MAX 1024px  ------------------------->
  <div class="desabilita mt-4" *ngIf="!carregando">
    <table class="table table-hover table-striped table-bordered">
      <thead class="thead-dark; border-color: #32383e;">
        <tr style=" color: #fff; background-color: #212529; border-color: #32383e;">
          <th translate class="text-center">{{'rmpv.oficina.mes'}}</th>
          <th translate class="text-center">{{'rmpv.oficina.marca'}}</th>
          <th class="text-center" *ngFor="let categoria of categorias"
            [translate]="getTranslate(categoria)"
          ></th>
          <!-- <th class="text-center">Internas</th> -->
          <th class="text-center">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of dados">
          <td class="text-right">{{item.mesAno}}</td>
          <ng-container *ngFor="let marca of item.marcas">
            <td class="text-right font-weight-bold">
              {{marca.marca}}
            </td>
            <td class="text-right" *ngFor="let categoria of marca.dados">
              {{categoria.faturamento | currency: ' '}}
            </td>
            <!-- <td class="text-right">
              {{marca.internas | currency: ' '}}
            </td> -->
            <td class="text-right">
              {{marca.total | currency: ' '}}
            </td>
          </ng-container>
      </tbody>
      <tfoot *ngIf="totalGeral">
        <tr style=" color: #fff; background-color: #212529; border-color: #32383e;">
          <td class="text-center font-weight-bold">
            Total
          </td>
          <ng-container *ngFor="let marca of totalGeral.marcas">
            <td class="text-center">
              {{marca.marca}}
            </td>
            <td class="text-right" *ngFor="let categoria of marca.dados">
              {{categoria.faturamento | currency: ' '}}
            </td>
            <!-- <td class="text-right">
              {{marca.internas | currency: ' '}}
            </td> -->
            <td class="text-right">
              {{marca.total | currency: ' '}}
            </td>
          </ng-container>
        </tr>
      </tfoot>
    </table>
  </div>

  <!----------------------------------------------------------------------------------------------->
  <div class="row alinhamentoBox">
    <div class="row desabilitaBox" *ngFor="let item of dados">
      <div class="col-md-4 container">
        <div class="box">
          <div class="row head-box">
            <div class="col-sm-1 head-box-cel"> <em class="fa fa-calendar-check-o" aria-hidden="true"></em> </div>
            <div translate class="col-sm-4 head-box-cel">{{'rmpv.oficina.mes'}}</div>
            <div class="col-sm-4 head-box-cel">{{item.mesAno}}</div>
          </div>
          <div class="row neck-box">
            <div translate class="col-sm-6 neck-box-cel">{{'rmpv.oficina.marcas'}}</div>
            <div class="col-sm-6 neck-box-cel" *ngFor="let marca of item.marcas">{{marca.marca}}</div>
          </div>
          <div class="row body">
            <div class="body-box">
              <div class="col-sm-3 row-striped body-box-cel-marcas" *ngFor="let categoria of categorias">{{categoria}}
              </div>
            </div>
            <div class="body-box" *ngFor="let marca of item.marcas">
              <div class="col-sm-3 row-striped body-box-cel" *ngFor="let categoria of marca.dados">
                {{categoria.faturamento | currency: ' '}}
                <!-- {{categoria.faturamento | currency: ' '}} -->
              </div>
            </div>
          </div>
          <!-- <div class="row foot-box">
        <div class="col-sm-6 foot-box-cel">Internas  </div> 
        <div class="col-sm-6 foot-box-cel" *ngFor="let marca of item.marcas"> {{marca.internas | currency: ' '}}  {{marca.internas | currency: ' '}}  </div> 
      </div> -->
          <div class="row foot-box">
            <div class="col-sm-6 foot-box-cel">Total </div>
            <div class="col-sm-6 foot-box-cel" *ngFor="let marca of item.marcas"> {{marca.total | currency: ' '}}
              <!-- {{marca.total | currency: ' '}}-->
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="row desabilitaBox" *ngIf="totalGeral">
      <div class="col-md-4 container">
        <div class="box">
          <div class="row head-box-total">
            <div class="col-sm-2 head-box-cel-icon"> <em class="fa fa-bar-chart"></em> </div>
            <div translate class="col-sm-5 head-box-total-cel">{{'rmpv.oficina.totalGeral'}}</div>
          </div>
          <div class="row neck-box">
            <div translate class="col-sm-6 neck-box-cel">{{'rmpv.oficina.marcas'}}</div>
            <div class="col-sm-6 neck-box-cel" *ngFor="let marca of totalGeral.marcas">{{marca.marca}}</div>
          </div>
          <div class="row body">
            <div class="body-box">
              <div class="col-sm-3 row-striped body-box-cel-marcas" *ngFor="let categoria of categorias">{{categoria}}
              </div>
            </div>
            <div class="body-box" *ngFor="let marca of totalGeral.marcas">
              <div class="col-sm-3 row-striped body-box-cel" *ngFor="let categoria of marca.dados">
                {{categoria.faturamento | currency: ' '}}
                <!--{{categoria.faturamento | currency: ' '}} -->
              </div>
            </div>
          </div>
          <!-- <div class="row foot-box">
        <div class="col-sm-6 foot-box-cel">Internas  </div> 
        <div class="col-sm-6 foot-box-cel" *ngFor="let marca of totalGeral.marcas">  {{marca.internas | currency: ' '}}  {{marca.internas | currency: ' '}} </div> 
      </div> -->
          <div class="row foot-box">
            <div class="col-sm-6 foot-box-cel">Total </div>
            <div class="col-sm-6 foot-box-cel" *ngFor="let marca of totalGeral.marcas">
              {{marca.total | currency: ' '}}
              <!-- {{marca.total | currency: ' '}} -->
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>